var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer-------------------Start
function fontResizer() {
  var perc = parseInt(sw) / 118.9375;
  document.body.style.fontSize = perc + "px";
}

// Loader-------------------Start
function pageLoader() {
  setTimeout(function () {
    $(".loader-wrapper").fadeOut();
    const myVivus = new Vivus(
      "my-svg",
      { duration: 200, type: "oneByOne" },
      function (obj) {
        obj.el.classList.add("finished");
        setTimeout(function () {
          $(".word1").css("left", "0");
          $(".word2").css("left", "0");
          setTimeout(function () {
            $(".logo-main-wrapper").css("transform", "translateY(30px)");
            $(".logo-main-wrapper").css("opacity", "0");
          }, 500);
          setTimeout(function () {
            $(".loader-clippath").fadeIn();
            setTimeout(function () {
              $(".loader-first").css("opacity", "0");
              $(".loader-first").css("transition", "1.2s ease");
              setTimeout(function () {
                $(".loader-first").fadeOut();
              }, 1500);
            }, 1200);
          }, 1000);
        }, 250);
      }
    );
    myVivus.play(2);
  }, 80);
  // setTimeout(function () {
  //   $("html").removeClass("loadjs");
  // }, 6000);
  // document.querySelector("html").classList.add("loadjs");
  setTimeout(function () {
    document.querySelector("html").classList.add("loaded");
  }, 6000);

  // setTimeout(function () {
  //   let loaderLogo = gsap
  //     .timeline({
  //       paused: false,
  //       repeat: 0,
  //     })
  //     .to(
  //       ".logoPath1",
  //       {
  //         "-webkit-clip-path": "inset(0% 0% 0% 0%)",
  //         "clip-path": "inset(0% 0% 0% 0%)",
  //         duration: 0.5,
  //       },
  //       0
  //     )
  //     .to(
  //       ".logoPath2",
  //       {
  //         "-webkit-clip-path": "inset(0% 0% 0% 0%)",
  //         "clip-path": "inset(0% 0% 0% 0%)",
  //         duration: 0.2,
  //       },
  //       0.5
  //     )
  //     .to(
  //       ".logoPath3",
  //       {
  //         "-webkit-clip-path": "inset(0% 0% 0% 0%)",
  //         "clip-path": "inset(0% 0% 0% 0%)",
  //         duration: 0.2,
  //       },
  //       0.7
  //     )
  //     .to(
  //       ".logoPath4",
  //       {
  //         "-webkit-clip-path": "inset(0% 0% 0% 0%)",
  //         "clip-path": "inset(0% 0% 0% 0%)",
  //         duration: 0.5,
  //       },
  //       0.9
  //     )
  //     .to(
  //       ".logoPath5",
  //       {
  //         "-webkit-clip-path": "inset(0% 0% 0% 0%)",
  //         "clip-path": "inset(0% 0% 0% 0%)",
  //         duration: 0.5,
  //       },
  //       1.4
  //     )
  //     .to(".logoPath6", { opacity: 1, top: 0, duration: 0.1 }, 1.9)
  //     .to(".logoPath7", { opacity: 1, top: 0, duration: 0.1 }, 2.0)
  //     .to(".logoPath8", { opacity: 1, top: 0, duration: 0.1 }, 2.1)
  //     .to(".logoPath9", { opacity: 1, top: 0, duration: 0.1 }, 2.2)
  //     .to(".logoPath10", { opacity: 1, top: 0, duration: 0.1 }, 2.3)
  //     .to(".logoPath11", { opacity: 1, top: 0, duration: 0.1 }, 2.4)
  //     .to(".logoPath12", { opacity: 1, top: 0, duration: 0.1 }, 2.5)
  //     .to(".logoPath13", { opacity: 1, top: 0, duration: 0.1 }, 2.6)
  //     .to(".logoPath14", { opacity: 1, top: 0, duration: 0.1 }, 2.7)
  //     .to(".logo-wrapper", { opacity: 0, scale: 1.5 }, 2.8)
  //     .to(".loader-first", { opacity: 0, duration: 0.5 })
  //     .to(".loader-first", { display: "none" });
  //     ;
  // }, 2000);

  // setTimeout(function () {
  //     document.querySelector(".loader-first").style.opacity = '0';
  //     document.querySelector(".loader-first").style.zIndex = '-1';
  //     document.querySelector(".loader-first").style.transition = '2s';
  // }, 2200);

  // if (sw < 520) {
  //     setTimeout(function () {
  //         document.querySelector(".loader-first").style.opacity = '0';
  //         document.querySelector(".loader-first").style.zIndex = '-1';
  //         document.querySelector(".loader-first").style.transition = '2s';
  //     }, 300);
  // }
}

// Navigation slide Active on a mobile
let toggleMenu = document.querySelector("#toggle");
let htmlEl = document.querySelector("html");

toggleMenu.addEventListener("click", (event) => {
  console.log("this", event);
  let _this = event.target;
  _this.classList.toggle("active");
  document.querySelector(".mega-menu").classList.toggle("open");
  htmlEl.classList.toggle("overflow-hidden");
});

// accordion
var accordion = document.getElementsByClassName("faqs__faq-accordion");
var j;

for (j = 0; j < accordion.length; j++) {
  accordion[j].querySelector("h4").addEventListener("click", function () {
    this.classList.toggle("opened");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    // console.log('checking height', panel.style.maxHeight)
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

// Landscape Mode off
function landscapeModeOff() {
  if (sh < 450 && sw > 480 && sw < 820) {
    document.getElementById("portrait-warnning").style.display = "flex";
  } else {
    document.getElementById("portrait-warnning").style.display = "none";
  }
}

// Sticky Header----------------Start
function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

function setNavigation() {
  let current_location = location.pathname.split("/")[1];
  if (current_location === "") return;
  let menu_items = document.querySelector("header").getElementsByTagName("a");
  for (let i = 0, len = menu_items.length; i < len; i++) {
    if (menu_items[i].getAttribute("href").indexOf(current_location) !== -1) {
      menu_items[i].classList.add("active");
    }
  }
}
setNavigation();

// Window on Load-----------------Start
window.onload = function () {
  pageLoader();
  if (sw > 1199) {
    fontResizer();
  }
  // SVG Convert Code
  let svgs = document.querySelectorAll("img.svg-convert");
  svgs.forEach((el) => {
    const imgID = el.getAttribute("id");
    const imgClass = el.getAttribute("class");
    const imgURL = el.getAttribute("src");

    fetch(imgURL)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "text/html");
        let svg = xmlDoc.querySelector("svg");
        if (typeof imgID !== "undefined") {
          svg.setAttribute("id", imgID);
        }

        if (typeof imgClass !== "undefined") {
          svg.setAttribute("class", imgClass + " svg-converted");
        }

        svg.removeAttribute("xmlns:a");

        el.parentNode.replaceChild(svg, el);
      });
  });
};

// Window On Resize-----------------Start
window.addEventListener("resize", (event) => {
  sw = window.innerWidth;
  sh = window.innerHeight;
  landscapeModeOff();
  if (sw > 1025) {
    if (sw < 1400 && sw > 1300 && sh > 900) {
    } else {
      fontResizer();
    }
  }
});

// let maintabs = document.querySelector('.masterful-chefs');
let tabscontent = document.querySelectorAll(".individual-pin");
const setActive = (el) => {
  [
    ...el.parentElement.parentElement.parentElement.parentElement.children,
  ].forEach((sib, i) => {
    sib
      .querySelectorAll(".best-talent__countryList li")
      .forEach((itemsib, i) => {
        itemsib.classList.remove("active");
      });
  });
  tabscontent.forEach((contentsib) => {
    contentsib.classList.remove("active");
  });

  el.classList.add("active");
  let activetabcontentid = el.getAttribute("data-src");
  let tabc = document.getElementById(activetabcontentid);
  if (tabc) {
    tabc.classList.add("active");
  }
};
let spans = [...document.body.querySelectorAll(".best-talent__countryList li")];
spans.forEach((el) => el.addEventListener("click", (e) => setActive(el)));

let innerLink = document.querySelectorAll(".js-inner");
innerLink.forEach((el) =>
  el.addEventListener("click", (e) =>
    functionforscroll(e.target.getAttribute("data-id"))
  )
);

$(".scrollSec").click(function () {
  $("html,body").animate(
    {
      scrollTop: $("#whoWe-are").offset().top,
    },
    "slow"
  );
});

function functionforscroll(id) {
  var getMeTo = document.getElementById(id);
  setTimeout(function () {
    getMeTo.scrollIntoView();
  }, 100);
  var uri = window.location.toString();
  if (uri.indexOf("#") > 0) {
    var clean_uri = uri.substring(0, uri.indexOf("#"));
    window.history.replaceState({}, document.title, clean_uri);
  }
}

// if (document.querySelector(".symbol-cards")) {
//   var grgDifference = new Swiper(".symbol-cards", {
//     watchSlidesProgress: !0,
//     spaceBetween: 10,
//     speed: 1500,
//     autoplay: {
//       enable: !0,
//       disableOnInteraction: !1,
//       delay: 1500,
//     },
//     breakpoints: {
//       640: {
//         slidesPerView: 3,
//       },
//       1024: {
//         slidesPerView: 4,
//         spaceBetween: 0,
//         allowTouchMove: false,
//       },
//     },
//   });
// }

if (document.querySelector(".excepteur-sint__cardWrapperSlider")) {
  var excepteurSint = new Swiper(".excepteur-sint__cardWrapperSlider", {
    watchSlidesProgress: !0,
    speed: 1500,
    autoplay: {
      enable: !0,
      disableOnInteraction: !1,
      delay: 1500,
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
        allowTouchMove: false,
      },
    },
  });
}

if (sw < 767) {
  if (document.querySelector(".above-beyond__logoWrapper")) {
    var aboveBeyond = new Swiper(".above-beyond__logoWrapper", {
      slidesPerView: 2,
      speed: 1500,
      autoplay: {
        enable: !0,
        disableOnInteraction: !1,
        delay: 1500,
      },
    });
  }
}

if ($(document).find("section").hasClass("counter-animation")) {
  var scroll_a = 0;
  $(window).scroll(function () {
    var oTop = $("#counter").offset().top - window.innerHeight;
    if (scroll_a == 0 && $(window).scrollTop() > oTop) {
      $(".counter").each(function () {
        var $this = $(this),
          countTo = $this.attr("data-count");
        $({
          countNum: $this.text(),
        }).animate(
          {
            countNum: countTo,
          },

          {
            duration: 1500,
            easing: "swing",
            step: function () {
              $this.text(Math.floor(this.countNum));
            },
            complete: function () {
              $this.text(this.countNum);
              //alert('finished');
            },
          }
        );
      });
      a = 1;
    }
  });
}

// window.onbeforeunload = function () {
//   window.scrollTo(0, 0);
// };

/* Custom Cursor Start */
function customCursor() {
  var cursor = $(".cursor"),
    follower = $(".cursor-follower");
  var posX = 0,
    posY = 0;
  var mouseX = 0,
    mouseY = 0;
  TweenMax.to({}, 0.01, {
    repeat: -1,
    onRepeat: function () {
      posX += (mouseX - posX) / 9;
      posY += (mouseY - posY) / 9;

      TweenMax.set(follower, {
        css: {
          left: posX - 0,
          top: posY - 0,
        },
      });

      TweenMax.set(cursor, {
        css: {
          left: mouseX,
          top: mouseY,
        },
      });
    },
  });
  $(document).on("mousemove", function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });
  $("a[href]").on("mouseenter", function () {
    cursor.addClass("hovered");
    follower.addClass("hovered");
  });
  $("a[href]").on("mouseleave", function () {
    cursor.removeClass("hovered");
    follower.removeClass("hovered");
  });
  $(".drag--img").on("mouseenter", function () {
    cursor.addClass("img-hover");
    follower.addClass("img-hover");
  });
  $(".drag--img").on("mouseleave", function () {
    cursor.removeClass("img-hover");
    follower.removeClass("img-hover");
  });
  $(".drag--img--white").on("mouseenter", function () {
    cursor.addClass("white-bg");
    follower.addClass("white-bg");
  });
  $(".drag--img--white").on("mouseleave", function () {
    cursor.removeClass("white-bg");
    follower.removeClass("white-bg");
  });
  $(".white--cursor").on("mouseenter", function () {
    cursor.addClass("white-col");
    follower.addClass("white-col");
  });
  $(".white--cursor").on("mouseleave", function () {
    cursor.removeClass("white-col");
    follower.removeClass("white-col");
  });
}

$(document).ready(function () {
  customCursor();
});
/* Custom Cursor End */

$(".menuHoverItem").on("mouseenter", function () {
  $(".mega-menu__rightWrapper").fadeIn();
});
$(".white--cursor").on("mouseleave", function () {
  setTimeout(function () {
      $(".mega-menu__rightWrapper").fadeOut();
  }, 1000);
});




if ("ontouchstart" in document.documentElement) {
  $(".plusArrow").click(function () {
    $(this).toggleClass("active");
    $(".mega-menu__rightWrapper").toggleClass("active");
  });
} else {
  $(".plusArrow").hide();
  $(".menuHoverItem").on("mouseenter", function () {
    $(".mega-menu__rightWrapper").fadeIn();
  });
  $(".menuHoverItem").on("mouseleave", function () {
    setTimeout(function () {
      if ($(".mega-menu__rightWrapper").hasClass("active")) {
      } else $(".mega-menu__rightWrapper").fadeOut();
    }, 650);
  });

  $(".mega-menu__rightWrapper").on("mouseenter", function () {
    $(".mega-menu__rightWrapper").addClass("active");
  });
  $(".mega-menu__rightWrapper").on("mouseleave", function () {
    $(".mega-menu__rightWrapper").removeClass("active");
    $(".mega-menu__rightWrapper").fadeOut();
  });
}
